import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, Loader2, Zap } from "lucide-react";
import { toast } from "sonner";

const BENEFITS = [
  "Bandingkan motor",
  "Hitung biaya kepemilikan",
  "Cek rute & tanjakan",
  "Simpan kandidat",
  "Gunakan fitur premium",
];

export function ThreeDayOfferModal() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user, isPremium } = useAuth();
  // Hanya untuk user free yang belum pernah membeli Paket Coba dan tidak sedang premium
  const eligible = !!user && !isPremium() && user.intro_pass_used !== true;

  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("show-3-day-offer", h);
    window.addEventListener("trial-exhausted", h);
    return () => {
      window.removeEventListener("show-3-day-offer", h);
      window.removeEventListener("trial-exhausted", h);
    };
  }, []);

  const startCheckout = async () => {
    setLoading(true);
    api.post("/meta/track", { event: "three_day_offer_clicked" }).catch(() => {});
    try {
      const { data } = await api.post("/payments/doku/checkout", { plan_id: "3_day_pass" });
      if (!data.payment_url) { toast.error("Pembayaran belum bisa dibuat. Silakan coba lagi nanti."); return; }
      window.location.assign(data.payment_url);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open && eligible} onOpenChange={setOpen}>
      <DialogContent className="bg-white max-w-md" data-testid="three-day-offer-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-navy"><Zap className="w-5 h-5 text-teal" />Analisis Anda sudah mulai terbentuk</DialogTitle>
          <DialogDescription className="sr-only">Penawaran Paket Coba 3 Hari seharga Rp5.000 setelah trial gratis selesai.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">Anda sudah menggunakan 2 kali akses gratis. Lanjutkan analisis semua kandidat selama 3 hari penuh.</p>
        <div className="bg-teal/5 border border-teal/20 rounded-2xl p-4 text-center my-2">
          <p className="font-heading font-extrabold text-3xl text-navy" data-testid="offer-price">Rp5.000</p>
          <p className="text-xs text-teal font-semibold">Akses penuh 3 hari</p>
        </div>
        <ul className="space-y-2">
          {BENEFITS.map((b) => <li key={b} className="flex items-start gap-2 text-sm text-navy"><Check className="w-4 h-4 text-teal mt-0.5 flex-shrink-0" />{b}</li>)}
        </ul>
        <div className="flex flex-col gap-2 mt-3">
          <Button data-testid="offer-checkout-btn" disabled={loading} onClick={startCheckout} className="rounded-full bg-teal hover:bg-teal-hover h-11">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Lanjutkan 3 Hari — Rp5.000"}
          </Button>
          <button data-testid="offer-other-plans" onClick={() => { setOpen(false); navigate("/premium"); }} className="text-sm text-muted-foreground hover:text-navy">Lihat Paket Lain</button>
        </div>
        <p className="text-xs text-center text-muted-foreground mt-1">Sekali bayar • Tidak diperpanjang otomatis</p>
      </DialogContent>
    </Dialog>
  );
}
